<template>
  <md-empty-state
    class="md-primary"
    md-icon="check_box_outline_blank"
    md-label="Está Vazio"
    md-description="Não há nenhum conteúdo cadastrado!">
  </md-empty-state>
</template>

<script>
  export default {
    name: "EmptyContentPage"
  }
</script>

<style scoped>

</style>
